import { contain } from 'react-container-helper';
import { connect } from 'react-redux';

import { normalizePathname } from 'util/path';

import App from './component';

const initState = () => {};

const mapSetStateToProps = (_, { ...props }) => ({
	...props,

	// disable hover effect on mobile device
	handleTouchStart() {
		document.body.style.cursor = 'pointer';
	},
});

const container = contain(initState, mapSetStateToProps)(App);

let gaPath = '';
const mapStateToProps = ({ routing: { locationBeforeTransitions: { pathname, search } }, global: { cookies } }) => {
	const pathnames = normalizePathname(pathname);
	const path = pathname + search;

	if (process.env.NODE_ENV === 'production' && window.ga) {
		if (path && gaPath !== path) {
			console.log('send', gaPath);
			gaPath = path;
			window.ga('set', 'page', gaPath);
			window.ga('send', 'pageview');
		}
	}

	return {
		page:
			pathnames[1] === '' ||
			pathnames[1] === 'promotions' ||
			pathnames[1] === 'main' ||
			pathnames[1] === 'privacy'
				? 'home'
				: pathnames[1],
		cookiesAccepted: cookies.acceptCookies === 'y',
	};
};

export default connect(mapStateToProps)(container);



// WEBPACK FOOTER //
// ./src/routes/container.js